import WhatsAppModal from './WhatsAppModal';
import { useState } from 'react';

export default function Hero() {
  const [modalOpen, setModalOpen] = useState(false);

  const WHATSAPP_NUMBER = '5514981800454';
  const WHATSAPP_MESSAGE = encodeURIComponent('Olá! Preciso de um guincho agora. Já estou ciente da política de pagamento antecipado.');

  const handleConfirm = () => {
    setModalOpen(false);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`, '_blank');
  };

  const scrollToArea = () => {
    document.getElementById('area')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <WhatsAppModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
      />

      <section className="relative min-h-screen flex items-center bg-gradient-to-br from-gray-50 to-white overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, black 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20 relative z-10 w-full">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Left Column */}
            <div className="space-y-6 md:space-y-8 text-center md:text-left">
              <div className="space-y-3 md:space-y-4">
                <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-black leading-tight">
                  GUINCHO EM
                  <br />
                  <span className="text-yellow-500">10 MINUTOS</span>
                </h1>
                <p className="text-lg md:text-2xl text-gray-600 font-medium">
                  Atendimento 24h em todo o Brasil
                </p>
              </div>

              {/* Time Badge */}
              <div className="inline-flex items-center gap-2 md:gap-3 bg-yellow-500 text-black font-bold px-5 py-3 md:px-8 md:py-4 rounded-full shadow-lg">
                <i className="ri-flashlight-fill text-xl md:text-2xl"></i>
                <span className="text-sm md:text-lg whitespace-nowrap">CHEGAMOS EM ATÉ 10 MIN</span>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4 items-center md:items-start">
                <button
                  onClick={() => setModalOpen(true)}
                  className="w-full sm:w-auto bg-yellow-500 text-black font-bold px-7 py-4 md:px-10 md:py-5 rounded-full text-base md:text-lg hover:bg-yellow-400 transition-all shadow-lg hover:shadow-xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  CHAMAR GUINCHO AGORA
                </button>
                <button
                  onClick={scrollToArea}
                  className="w-full sm:w-auto border-2 border-black text-black font-bold px-7 py-4 md:px-10 md:py-5 rounded-full text-base md:text-lg hover:bg-black hover:text-white transition-all whitespace-nowrap cursor-pointer"
                >
                  VER ÁREA DE ATUAÇÃO
                </button>
              </div>

              {/* Trust Indicators */}
              <div className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-6 pt-2 md:pt-4">
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-fill text-xl md:text-2xl text-green-500"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">Seguro e Confiável</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-star-fill text-xl md:text-2xl text-yellow-500"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">+5000 Atendimentos</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-time-fill text-xl md:text-2xl text-gray-500"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">Disponível 24/7</span>
                </div>
              </div>
            </div>

            {/* Right Column - Image (hidden on mobile) */}
            <div className="relative hidden md:block">
              <div className="relative transform rotate-2 hover:rotate-0 transition-transform duration-500">
                <img
                  src="https://static.readdy.ai/image/bbfcf3c80fb45280233f421c8e77190f/85acb874c5b9c2be305d6ec1438743db.png"
                  alt="Guincho Profissional"
                  className="w-full h-auto rounded-3xl shadow-2xl object-cover"
                />
              </div>

              <div className="absolute top-8 -right-4 bg-white rounded-2xl shadow-xl px-6 py-4 transform hover:scale-105 transition-transform">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                    <i className="ri-time-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-black">24/7</p>
                    <p className="text-sm text-gray-600">Disponível</p>
                  </div>
                </div>
              </div>

              <div className="absolute top-1/2 -left-4 bg-white rounded-2xl shadow-xl px-6 py-4 transform hover:scale-105 transition-transform">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gray-500 rounded-full flex items-center justify-center">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-black">Todo Brasil</p>
                    <p className="text-sm text-gray-600">Cobertura</p>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-8 -right-4 bg-white rounded-2xl shadow-xl px-6 py-4 transform hover:scale-105 transition-transform">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center">
                    <i className="ri-bank-card-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="font-bold text-black">Pagamento</p>
                    <p className="text-sm text-gray-600">Facilitado</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
